import * as React from 'react';
import { BooleanField, BulkDeleteButton, Datagrid, List, ReferenceField, TextField } from 'react-admin';
import { CustomTitle } from '../../components/CustomTitle';
import { IndexField } from '../../components/IndexField';
import { ListActions } from '../../components/ListAction';
import { ListIsEmptyPage } from '../../components/ListIsEmptyPage';
import { paginationProps } from '../../components/Paginator';
import BulkSwapLastNameButton from './BulkSwapLastNameButton';
import { ConfsForSpeaker } from './ConfsForSpeaker';
import MergeSpeakersButton, { IMergeSpeakersButtonProps } from './MergeSpeakers';

const BulkActionButtons = (props: unknown) => (
  <>
    <BulkSwapLastNameButton {...props} />
    <MergeSpeakersButton {...(props as IMergeSpeakersButtonProps)} />
    <BulkDeleteButton />
  </>
);

export const SpeakerList = (props: unknown) => (
  <List
    sort={{ field: 'title', order: 'ASC' }}
    empty={<ListIsEmptyPage />}
    {...paginationProps}
    bulkActionButtons={<BulkActionButtons />}
    actions={<ListActions />}
    title={<CustomTitle />}
    {...props}
  >
    <Datagrid rowClick="edit">
      <IndexField label="#" sortable={false} />
      <ReferenceField source="id" reference="speakers" link="show" label="Firstname">
        <TextField source="firstname" />
      </ReferenceField>
      <ReferenceField source="id" reference="speakers" link="show" label="Lastname">
        <TextField source="lastname" />
      </ReferenceField>
      <ReferenceField source="countryId" reference="countries">
        <TextField source="title" />
      </ReferenceField>
      <TextField source="cv" />
      <BooleanField source="isRockStar" />
      <ConfsForSpeaker asChip={true} source="ConfsForSpeaker" />
      <TextField source="id" />
    </Datagrid>
  </List>
);
